<tidy-card
  class="task-card"
  [class.suggested]="isSuggested"
  (click)="onCardClick()">
  @if (isSuggested && showArrowOnly) {
    <tidy-row [alignLastItemRight]="true">
      <tidy-image
        [src]="'assets/svg/bulb-outline.svg'"
        class="title-size"
        style="filter: brightness(0) invert(1); margin-right: 8px;" />
      <tidy-text [body]="title" />
      <tidy-image
        [src]="'assets/svg/chevron-forward-outline.svg'"
        class="body-size"
        style="filter: brightness(0) invert(0.6);" />
    </tidy-row>
  } @else if (isSuggested) {
    <tidy-row [alignLastItemRight]="true">
      <tidy-text [body]="title" />
      <div class="card-actions">
        <button class="action-btn" (click)="onRejectClick($event)">
          <tidy-image [src]="'assets/svg/close-outline.svg'" class="body-size" />
        </button>
      </div>
    </tidy-row>
    <tidy-row class="no-padding" [alignLastItemRight]="true">
      <tidy-image [src]="priorityIcon" />
      <tidy-text [secondaryBody]="address" />
      <div class="card-actions">
        <button class="action-btn" (click)="onAcceptClick($event)">
          <tidy-image [src]="'assets/svg/add-outline.svg'" class="body-size" />
        </button>
      </div>
    </tidy-row>
  } @else {
    <tidy-row [alignLastItemRight]="true">
      <tidy-text
        [ngStyle]="checkedUsers?.length > 1 ? {'max-width': '15ch'} : {'max-width': '50ch'}"
        [body]="title" />
      <div class="card-actions">
        @if (!checkedUsers?.length) {
          <tidy-image
            mat-icon-button [matMenuTriggerFor]="userMenu" (click)="$event.stopPropagation()"
            [src]="'assets/img/assign.svg'"
            class="header-size secondary-text-icon no-right-margin" />
        }
        @if (getUserIcon() === 'user') {
          <div class="user-initials" [ngClass]="!checkedUsers?.length ? 'thirty-percent-opacity button-hover' : 'button-hover'" mat-icon-button [matMenuTriggerFor]="userMenu" (click)="$event.stopPropagation()" [style.background]="util.getAvatarGradient(checkedUsers[0]?.name || 'BA')">
            {{ checkedUsers[0]?.name | initials }}
          </div>
        }
        @if (getUserIcon() === 'concierge') {
          <tidy-image
            class="button-hover no-right-margin" style="width: 18px" mat-icon-button [matMenuTriggerFor]="userMenu" (click)="$event.stopPropagation()"
            [src]="'assets/img/concierge.svg'" />
        }
        @if (checkedUsers?.length > 1) {
          <tidy-text
            style="margin-left: 3px"
            [body]="'+' + checkedUsers?.length - 1" />
        }
        <mat-menu #userMenu="matMenu">
          @for (user of allUsers; track $index) {
            <button mat-menu-item>
              <mat-checkbox
                class="checkbox"
                [checked]="user?.checked"
                (click)="$event.stopPropagation()"
                (change)="onUserCheck(user, $event)">
                {{user?.name}}
              </mat-checkbox>
            </button>
          }
        </mat-menu>
      </div>
    </tidy-row>
    <tidy-row class="no-padding" [alignLastItemRight]="true">
      <tidy-image [src]="priorityIcon" />
      <tidy-text [secondaryBody]="address" />
      <div class="card-actions">
        @if (!checkedJobs?.length) {
          <tidy-image
            mat-icon-button [matMenuTriggerFor]="jobMenu" (click)="onJobMenuOpen($event)"
            [src]="'assets/img/calendar-plus.svg'"
            class="header-size secondary-text-icon no-right-margin" />
        }
        @if (checkedJobs?.length) {
          <ion-chip class="job-chip no-padding" mat-icon-button [matMenuTriggerFor]="jobMenu" (click)="onJobMenuOpen($event)">
            <tidy-image
              [src]="checkedJobs[0]?.icon_url"
              style="height: 25px" />
            @if (checkedJobs[0]?.status?.icon_type === 'image') {
              <tidy-image
                [src]="checkedJobs[0]?.status?.icon"
                [ngClass]="checkedJobs[0]?.status?.class ? checkedJobs[0]?.status?.class : ''"
                style="height: 25px" />
            }
            @if (checkedJobs[0]?.status?.icon_type === 'initials') {
              <div
                [ngClass]="checkedJobs[0]?.status?.class"
                [style.background]="util.getAvatarGradient(checkedJobs[0]?.status?.initials || 'BA')">
                {{checkedJobs[0]?.status?.initials | uppercase}}
              </div>
            }
          </ion-chip>
        }
        <mat-menu #jobMenu="matMenu" style="max-width: 600px !important;">
          @if (jobSearchForm) {
            <div style="padding: 10px; border-bottom: 1px solid #e0e0e0;" (click)="$event.stopPropagation()">
              <form [formGroup]="jobSearchForm" novalidate action="#">
                <tidy-search-input
                  formControlName="search"
                  [placeholder]="'Search jobs'"
                  [icon]="'assets/svg/search-outline.svg'"
                  (click)="$event.stopPropagation()"
                  (focus)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()" />
              </form>
            </div>
          }
          @for (job of filteredJobs; track $index) {
            <button mat-menu-item class="tree-node-padding" style="display: flex; align-items: center; justify-content: space-between; width: 100%">
              <mat-checkbox
                class="checkbox"
                (click)="$event.stopPropagation()"
                [checked]="job?.checked"
                (change)="onJobCheck(job, $event)">
                <tidy-text [body]="job?.name" /><span>&nbsp;</span>
                <tidy-text [helper]="'-'" /><span>&nbsp;</span>
                <tidy-text [helper]="job?.service_name" style="margin-right: 5px" />
              </mat-checkbox>
              <tidy-image
                [src]="'assets/img/chevron-right.svg'"
                class="right-item chevron-icon no-right-margin"
                (action)="onGoToJob(job, $event)" />
            </button>
          }
          @if (filteredJobs && !filteredJobs?.length && allJobs?.length) {
            <div style="margin: 10px;">
              <tidy-text [helper]="'<i>No results</i>'" />
            </div>
          }
          @if (!allJobs?.length && allJobs) {
            <div style="margin: 10px;">
              <tidy-text [helper]="'<i>No jobs booked</i>'" />
            </div>
          }
          @if (!allJobs) {
            <div style="margin: 10px;">
              <tidy-text [helper]="'Loading jobs...'" />
            </div>
          }
          <mat-divider />
          <tidy-row class="vertical-align-center extra-top-padding extra-bottom-padding" style="margin-left: 7px; margin-right: 10px">
            <tidy-image
              [src]="'assets/svg/add-circle-outline.svg'"
              class="header-size" />
            <tidy-text
              [actionBody]="'Add Job'"
              (action)="onAddJobClick()" />
          </tidy-row>
        </mat-menu>
      </div>
    </tidy-row>
    @if (dueDate) {
      <tidy-row class="vertical-align-center extra-top-padding">
        <tidy-image
          [src]="'assets/svg/calendar.svg'"
          class="body-size" />
        <tidy-text
          [smallBody]="dueDate | formatDueDate"
          [ngClass]="{'red': isDueDateInPast(dueDate)}" />
      </tidy-row>
    }
  }
</tidy-card>
